import React, { Fragment } from "react";
import styled, { css } from "styled-components";

/*
  data: array

  data.status: String
  data.text: String
*/
const Label = (props) => {
  const { data } = props;

  return (
    <Container status={data.status}>
      <Body status={data.status}>
        {data.leftIcon && <img src={data.leftIcon} />}
        {data.text}
      </Body>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: ${(props) =>
    props.status === "active"
      ? "rgba(107, 101, 222, 0.1)"
      : props.status === "active_green"
      ? "rgba(34, 197, 94, 0.1)"
      : "#F2F2F5"};
`;

const Body = styled.p`
  display: flex;
  gap: 4px;
  color: ${(props) =>
    props.status === "active"
      ? "var(--Primary, #6b65de)"
      : props.status === "active_green"
      ? "#22c55e"
      : "#666"};

  /* Body/3/Medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;

export default Label;
